// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__jwgfR","leftClass":"Checkbox_leftClass__WqkP+","rightClass":"Checkbox_rightClass__GPhWK","rightClass-login":"Checkbox_rightClass-login__CAgpi"};